import { createContext } from "react";

import { type DatatableState } from "@/domain/view/models/datatable-state-model";
import { type Table } from "@tanstack/react-table";

import { type DatatableLock } from "../datatable-lock";
import { type DatatableColumn, type DatatableRowData, type TSectionData } from "../datatable-types";

export interface DatatableContextType<TData extends DatatableRowData> {
  table: Table<TSectionData<TData>>;
  columns: DatatableColumn<TData>[];
  state: DatatableState;
  setState: (params: { state: Partial<DatatableState>; skipApiPropagation?: boolean }) => void;
  isPaginationEnabled: boolean;
  rowCount: number;
  lock: DatatableLock;

  getConfigurationForColumn: (columnId: string) => DatatableColumn<TData> | undefined;
}

// createContext cannot carry the provider's generic.
export const DatatableContext = createContext<unknown>(null);
